/**
 * Local backend base URL. Prefer REACT_APP_LOCAL_API_URL for non-default ports.
 */
const localApiBase = () =>
  (process.env.REACT_APP_LOCAL_API_URL || 'http://localhost:3001').replace(/\/$/, '');

/**
 * @param {string} endpoint
 * @returns {string}
 */
const endpointPath = (endpoint) => {
  try {
    const u = new URL(endpoint);
    return `${u.pathname}${u.search}`;
  } catch (_) {
    const parts = String(endpoint).split(/localhost:\d+/);
    return parts[1] || endpoint;
  }
};

const createUnsignedRequest = async (method, endpoint, data = null, headers) => {
  let resolvedEndpoint = endpoint;

  // For Local Testing — rewrite host/port without assuming :3001
  if (process.env.REACT_APP_LOCAL_BACK_TEST) {
    const path = endpointPath(endpoint);
    if (['/payment'].some((x) => endpoint.includes(x))) {
      resolvedEndpoint = `http://localhost:3002${path}`;
    } else if (['/registration', '/authentication'].some((x) => endpoint.includes(x))) {
      resolvedEndpoint = `http://localhost:3003${path}`;
    } else {
      resolvedEndpoint = `${localApiBase()}${path}`;
    }
  }

  const hasBody = data != null && data !== '';
  const unsignedRequest = await fetch(resolvedEndpoint, {
    method,
    ...(hasBody ? { body: data } : {}),
    headers: {
      Accept: 'application/json',
      ...(hasBody ? { 'Content-Type': 'application/json' } : {}),
      ...headers,
    },
  });

  return unsignedRequest;
};

export default createUnsignedRequest;
